export function splitBitFlag(flag) {
    const output = [];
    for (let i = 0; i < 32; i++) {
        // eslint-disable-next-line no-bitwise
        if (flag & (1 << i)) {
            output.push(2 ** i);
        }
    }
    return output;
}
export function toBitFlag(numbers) {
    return numbers.reduce((total, n) => total + Number(n), 0);
}
export function betweenIncl(x, min, max) {
    try {
        return x >= min && x <= max;
    }
    catch (error) {
        console.error(error);
        return false;
    }
}
export function precisionRound(number, precision = 2) {
    const factor = 10 ** precision;
    return Math.round(number * factor) / factor;
}
export function precisionFloor(number, precision) {
    const factor = 10 ** precision;
    return Math.floor(number * factor) / factor;
}
export function isMinusZero(n) {
    return n === '-0' || n === '-00';
}
